export default __webpack_public_path__ + "static/media/Rejected.62ad82ba.svg";